// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { B300, B400, N100, N50 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var AttachmentFieldContainer = styled.div({
  paddingTop: "var(--ds-space-150, 12px)",
  paddingBottom: "var(--ds-space-150, 12px)",
  border: "1px dashed ".concat("var(--ds-border, ".concat(N50, ")")),
  color: "var(--ds-text-subtlest, ".concat(N100, ")")
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var FieldDropzoneContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  padding: "var(--ds-space-150, 12px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var MediaContainer = styled.div({
  marginTop: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var BrowseDropzoneArea = styled.span({
  display: 'flex',
  alignItems: 'center'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var IconContainer = styled.span({
  marginRight: "var(--ds-space-050, 4px)"
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var DragCardContainer = styled.div({
  color: "var(--ds-icon-accent-blue, ".concat(B400, ")"),
  background: "var(--ds-background-accent-blue-subtle, ".concat(B300, ")"),
  borderRadius: '3px',
  width: '150px',
  minHeight: '100px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});